import { Select, Tag } from 'antd';
import React from 'react';
import { PeopleInterface } from 'type/peopleType';

// Enhanced Cast Editor Component (editable)
interface EnhancedCastEditorProps {
  value?: { cast: number; type: string }[];
  onChange?: (value: { cast: number; type: string }[]) => void;
  peopleList?: PeopleInterface[];
  onSearchPeople?: (searchTerm: string) => void;
}

const EnhancedCastEditor: React.FC<EnhancedCastEditorProps> = ({
  value = [],
  onChange,
  peopleList = [],
  onSearchPeople
}) => {
  // 사용할 cast type 정의 (기존 typeLabels의 3개만)
  const castTypes = [
    { value: 'director', label: 'Director' },
    { value: 'writer', label: 'Writer' },
    { value: 'actor', label: 'Actor' }
  ];

  // type별로 그룹핑된 cast 데이터
  const groupedCast = castTypes.reduce((acc, typeOption) => {
    acc[typeOption.value] = value.filter(item => item.type === typeOption.value);
    return acc;
  }, {} as Record<string, { cast: number; type: string }[]>);

  // cast ID를 이름으로 변환하는 함수
  const getCastName = (castId: number): string => {
    const person = peopleList.find(p => p.id === castId);
    return person ? person.name : `Cast ID: ${castId}`;
  };

  // 특정 타입의 cast 변경 핸들러
  const handleCastChange = (type: string, selectedCastIds: number[]) => {
    // 현재 타입이 아닌 다른 타입들의 cast는 유지
    const otherTypeCasts = value.filter(item => item.type !== type);

    // 새로 선택된 cast들을 해당 타입으로 추가
    const newTypeCasts = selectedCastIds.map(castId => ({
      cast: castId,
      type: type
    }));

    // 전체 enhanced_cast 배열 업데이트
    const updatedValue = [...otherTypeCasts, ...newTypeCasts];
    onChange?.(updatedValue);
  };

  return (
    <div style={{ border: '1px solid #d9d9d9', borderRadius: '6px', padding: '12px' }}>
      {castTypes.map(typeOption => {
        const currentCasts = groupedCast[typeOption.value] || [];
        const currentCastIds = currentCasts.map(item => item.cast);

        return (
          <div key={typeOption.value} style={{ marginBottom: '16px' }}>
            <div style={{ marginBottom: '8px' }}>
              <Tag color="blue" style={{ fontSize: '12px', padding: '2px 8px' }}>
                {typeOption.label}
              </Tag>
            </div>
            <Select
              mode="multiple"
              showSearch
              style={{ width: '100%' }}
              placeholder={`Search and select ${typeOption.label}`}
              value={currentCastIds}
              onChange={(selectedIds: number[]) => handleCastChange(typeOption.value, selectedIds)}
              onSearch={onSearchPeople}
              filterOption={false}
              options={peopleList.map(person => ({
                label: person.name,
                value: person.id,
              }))}
            />
          </div>
        );
      })}
    </div>
  );
};

export default EnhancedCastEditor;

